module.exports = __webpack_public_path__ + "img/Caio-Silva.efe7677c.png";